module.exports = require("js-cookie");